module.exports = __webpack_public_path__ + "img/command.ab670e72.svg";